export const ROLE_CS_MANAGER = "customer_support_manager";
export const ROLE_CS = "customer_support";

export const ROLE_DOCTOR = "doctor";
export const ROLE_NURSE = "nurse";
export const ROLE_HCSW = "health_care_support_worker";
export const ROLE_CS_EXECUTIVE = "customer_support_executive";
export const ROLE_THERAPIST = "therapist";

export const DATE_FORMAT = "DD-MM-YYYY";
export const T24_HR_FORMAT = "HH:mm";
export const DATE_FORMAT_24_HR = "DD-MM-YYYY HH:mm";
export const COMMUNITY_USER = "community";
export const CORPORATE_USER = "corporate";

export const rolesArray = {
  doctor: {
    key: "doctor",
    value: "Doctor",
  },
  health_care_support_worker: {
    key: "health_care_support_worker",
    value: "HCA",
  },
  nurse: {
    key: "nurse",
    value: "Nurse",
  },
};

export const spaceRegex = /^(?=.*\S).+$/;
export const passwordRegex =
  /^(?=.*[\d])(?=.*?[A-Z])(?=.*[!@#$%^&*])[\w!@#$%^&*]{8,}$/;

export const devCorporateArray = [
  {id: 83, corporate_name: "Priory"},
  {id: 87, corporate_name: "Care First"},
  {id: 66, corporate_name: "AllDayDr"},
];
export const prodCorporateArray = [
  {id: 64, corporate_name: "Priory"},
  {id: 65, corporate_name: "Care First"},
  {id: 66, corporate_name: "AllDayDr"},
];

export const stageCorporateArray = [
  {id: 42, corporate_name: "Priory"},
  {id: 44, corporate_name: "Care First"},
  {id: 41, corporate_name: "AllDayDr"},
];

export const PRIORY_CORPORATE = "Priory Group";
export const CARE_FIRST_CORPORATE = "Care First";
export const ALLDAYDR_CORPORATE = "AllDayDr Common Corporate";

export const APPT_TYPE_VIDEO = "video";
export const APPT_TYPE_WALKIN = "face_to_face";
export const APPT_TYPE_AUDIO = "phone_call";
